import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { CustomerDataProvider } from "./hooks/CustomerDataProvider";
import { EntitlementProvider } from "./hooks/EntitlementProvider";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    {/* v1.4.6 — one fetch shared across all 16 consumers. See
        /app/frontend/src/hooks/CustomerDataProvider.jsx. */}
    <CustomerDataProvider>
      <EntitlementProvider>
        <App />
      </EntitlementProvider>
    </CustomerDataProvider>
  </BrowserRouter>
);